import { GatewayMe } from "@conformite/gateway";
import {
  Button,
  FormField,
  FormGrid,
  FormRow,
  displayErrorToast,
  InfoCard,
} from "@endya-conformite/ui-kit";
import { GatewayMeApi } from "@src/api/me.api";
import { handleGatewayError } from "@src/api/utils/handleGatewayError";
import Download from "@endya-conformite/ui-kit/src/assets/icons/download.svg?react";
import { useEffect, useState } from "react";
import styles from "./AdhesionVirementPage.module.scss";

export function AdhesionVirementPage() {
  const [me, setMe] = useState<GatewayMe.GetMeResponse>();

  useEffect(() => {
    GatewayMeApi.getMe()
      .then(setMe)
      .catch((error) =>
        handleGatewayError({
          onUnhandled: () => {
            displayErrorToast("Une erreur est survenue");
            console.error(error);
          },
        })(error)
      );
  }, []);

  if (!me) return null;
  return (
    <FormGrid>
      <FormRow>
        <FormField>
          <h2>Paiement par virement</h2>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <InfoCard>
            Indiquez le numéro SIREN dans la référence du virement :{" "}
            <b>{me.entreprisePrincipale.siren}</b>
          </InfoCard>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <Button icon={<Download />} variant="text">
            <a
              href="https://endya-public.s3.eu-west-3.amazonaws.com/rib_endya.pdf"
              target="_blank"
              rel="noreferrer"
              download
              className={styles.downloadLink}
            >
              Télécharger le RIB
            </a>
          </Button>
        </FormField>
      </FormRow>
    </FormGrid>
  );
}
